module.exports = __webpack_public_path__ + "img/success.cac24ee6.png";